import { CustomerComment } from './CheckoutUtils';
import RestaurantHelper from '@wix/wixrest-utils/dist/openrest-helpers/Restaurant';
import _ from 'lodash';
import { DeliveryTypes } from './constants';
import moment from 'moment';
import { TimeUtils } from '@wix/wixrest-utils';

export function getLatestComment(comments) {
  if (!comments) {
    return {};
  }
  let latestComment = {
    timestamp: 0,
  };
  comments.forEach(comment => {
    if (comment.timestamp > latestComment.timestamp) {
      latestComment = comment;
    }
  });
  return latestComment.timestamp === 0 ? {} : latestComment;
}

export function parseComments(json) {
  try {
    return JSON.parse(json.properties['com.wix.restaurants']).comments.map(comment => new CustomerComment(comment));
  } catch (e) {
    return [];
  }
}

export function getSupportedDeliveryTypes(restaurant) {
  const deliveryOptions = RestaurantHelper.getDeliveryOptions({ restaurant });

  const supportedDeliveryTypes = [];
  if (deliveryOptions.hasDelivery && _.get(deliveryOptions, 'delivery.available')) {
    supportedDeliveryTypes.push(DeliveryTypes.DELIVERY);
  }

  if (deliveryOptions.hasTakeout && _.get(deliveryOptions, 'takeout.available')) {
    supportedDeliveryTypes.push(DeliveryTypes.TAKEOUT);
  }

  return supportedDeliveryTypes;
}

export function getOrderDeliveryTime(orderData, locale) {
  const created = moment(orderData.created).locale(locale);
  const futureDeliveryTime = moment(_.get(orderData, 'delivery.time'));
  return TimeUtils.humanizeMinutesDuration(futureDeliveryTime.diff(created, 'm'));
}
